import {
  ActivitiesEmailsFieldNames,
  AutoLockFormsLevelType,
  FormNames,
} from '../autoLockForms.constants';

const formFields = [
  {
    name: 'recipients',
    label: 'To',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cc',
    label: 'CC',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bcc',
    label: 'BCC',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'subject',
    label: 'Subject',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: ActivitiesEmailsFieldNames.BODY,
    label: 'Body',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: ActivitiesEmailsFieldNames.FILES,
    label: 'Files',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const activitiesEmailsForm = {
  name: FormNames.ACTIVITIES_EMAILS,
  label: 'Emails',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
